import { useMemo } from 'react'
import { ReduceMotion, type WithSpringConfig } from 'react-native-reanimated'

/** A spring fitted to the release/settle motion in the Stocks reference. */
export function useV2DrawerMotion(): WithSpringConfig {
  return useMemo(
    () => ({
      // ω = 18 rad/s, ζ = 0.8: a small overshoot followed by a soft settle.
      mass: 1,
      stiffness: 324,
      damping: 28.8,
      overshootClamping: false,
      reduceMotion: ReduceMotion.System,
      // No duration/easing: Gorhom routes either to withTiming, losing momentum.
      // Leave velocity unset so each gesture supplies its release velocity.
    }),
    [],
  )
}
